import { WebsocketCommandResponse } from '../MainWebsocketCommands';
import { WebsocketCommand } from '../useManagedWebsocket';

export class WebsocketSpotSlotsStatesCommand extends WebsocketCommand {
    public async execute(fullStateCheck: () => Promise<void>): Promise<WebsocketCommandResponse> {
        await fullStateCheck();
        return { success: true };
    }
}
